import {
  SOLUTION_TYPE,
  SolutionType,
} from '../../../../../../shared/constants/user-info/solutionType';

const solutionOptions: Record<
  Exclude<SolutionType, typeof SOLUTION_TYPE.CHALLENGE>,
  SolutionType[]
> = {
  [SOLUTION_TYPE.NUTRITION]: [
    SOLUTION_TYPE.NUTRITION,
    SOLUTION_TYPE.SCAN_IQ,
    SOLUTION_TYPE.CHALLENGE,
  ],
  [SOLUTION_TYPE.SCAN_IQ]: [SOLUTION_TYPE.SCAN_IQ, SOLUTION_TYPE.CHALLENGE],
};

export const getDefaultSolutionValue = (activeSolution: SolutionType | null) => {
  if (!activeSolution) {
    throw new Error('Solution is not selected');
  }

  if (activeSolution === SOLUTION_TYPE.CHALLENGE) {
    throw new Error('Challenges solution is not supported');
  }

  return solutionOptions[activeSolution];
};
